import * as React from 'react';
import { FUI_FRAME_EVENT } from './useIFrameFocusDispatch';

/**
 * Set a listener for a custom event emmited by the useIFrameFocusDispatch to execute the callback
 */
export var useIFrameListener = function useIFrameListener(enableFrameFocusDispatch, callback, targetDocument) {
  var listener = React.useCallback(function (e) {
    if (callback) {
      callback(e);
    }
  }, [callback]);
  React.useEffect(function () {
    if (enableFrameFocusDispatch) {
      targetDocument == null ? void 0 : targetDocument.addEventListener(FUI_FRAME_EVENT, listener);
    }
    return function () {
      targetDocument == null ? void 0 : targetDocument.removeEventListener(FUI_FRAME_EVENT, listener);
    };
  }, [targetDocument, enableFrameFocusDispatch, listener]);
};
//# sourceMappingURL=useIFrameListener.js.map
